import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginLeft: -theme.spacing(1),
    // Match the 48px top of the error-details view (MUI pins the DialogContent
    // first-child paddingTop to 20px; add the remainder).
    marginTop: theme.spacing(7),
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  },
  backIcon: {
    width: 20,
    height: 20
  },
  backLabel: {
    color: theme.colorPalette.orange_50
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  title: {
    color: theme.colorPalette.green_75
  },
  intro: {
    color: theme.colorPalette.green_80
  },
  field: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  fieldLabel: {
    color: theme.colorPalette.green_75
  },
  optional: {
    color: theme.colorPalette.green_75,
    textTransform: 'none',
    fontWeight: 400
  },
  buttons: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    minWidth: 140
  }
}));

export default useStyles;
